var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useMutation } from "react-query";
import { updatePublisherAction, takeOverPublisher, } from "../../../api/publisherService";
import { fetchPublisherUpdateRequests } from "../../../api/publisherUpdateRequestService";
import { useInvalidatePublisher } from "../../../hooks/usePublisherQuery";
import { publisherActionMessageId } from "../../../utils/publisherActionError";
export var usePublisherActions = function (selectedPublisher, refetch, closeDetail) {
    var ky = useOkapiKy();
    var history = useHistory();
    var location = useLocation();
    var invalidatePublisher = useInvalidatePublisher();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(null), messageBanner = _a[0], setMessageBanner = _a[1];
    useEffect(function () {
        setMessageBanner(null);
    }, [location.search]);
    var takeOver = useMutation({
        mutationFn: function (publisherId) { return takeOverPublisher(ky, publisherId); },
    }).mutateAsync;
    var refetchPublisher = function () { return invalidatePublisher(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id); };
    /** A failed status action is shown to the user (RECEK-76282), e.g. the refusal of another publisher. */
    var showActionError = function (error, fallbackMessageId) {
        return setMessageBanner({
            type: "error",
            message: formatMessage({
                id: publisherActionMessageId(error, fallbackMessageId),
            }),
        });
    };
    var handleCloseClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, updatePublisherAction(ky, selectedPublisher.id, "closing")];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refetch()];
                case 3:
                    _a.sent();
                    closeDetail();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Error closing publisher:", error_1);
                    showActionError(error_1, "ui-br-publishers.publishers.error.closing");
                    // the confirmation dialog reports the failure instead of a success
                    throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleTakeOverClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, takeOver(selectedPublisher.id)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all([refetch(), refetchPublisher()])];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    console.error("Error taking over publisher:", error_2);
                    // the confirmation dialog reports the failure instead of a success
                    throw error_2;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleConfirmClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, updatePublisherAction(ky, selectedPublisher.id, "confirmData")];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all([refetch(), refetchPublisher()])];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_3 = _a.sent();
                    console.error("Error confirming publisher:", error_3);
                    showActionError(error_3, "ui-br-publishers.publishers.error.confirmData");
                    // the confirmation dialog reports the failure instead of a success
                    throw error_3;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleEditClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchPublisherUpdateRequests(ky, {
                            status: "SUBMITTED",
                            publisherId: selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id,
                        })];
                case 1:
                    data = _a.sent();
                    if (data.totalRecords > 0) {
                        setMessageBanner({
                            type: "warning",
                            message: formatMessage({
                                id: "ui-br-publishers.publishers.update.request.exists.message",
                            }),
                        });
                    }
                    else {
                        history.push("/brpublishers/publishers/edit/".concat(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.error("Error fetching publisher update requests:", error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleRegistrationSuccess = function (updatedPublisher) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all([refetch(), invalidatePublisher(updatedPublisher.id)])];
                case 1:
                    _a.sent();
                    setMessageBanner({
                        type: "success",
                        message: formatMessage({
                            id: "ui-br-publishers.publishers.registrations.success.registered",
                        }),
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        handleCloseClick: handleCloseClick,
        handleTakeOverClick: handleTakeOverClick,
        handleConfirmClick: handleConfirmClick,
        handleEditClick: handleEditClick,
        handleRegistrationSuccess: handleRegistrationSuccess,
        messageBanner: messageBanner,
        setMessageBanner: setMessageBanner,
    };
};
